import ButtonComponent from "../../../components/buttonComponent";
import RefreshIcon from '@mui/icons-material/Refresh';

const MatTableHeader = (props) => {
    const {getTableData, headerText} = props;
    return (
        <>
            <div className="flex py-2 pr-3 flex-nowrap space-x-2 w-full pl-2 mr-0 justify-between items-center">
                <p className="pt-1 rounded-sm flex-grow text-left">{headerText}</p>
                <ButtonComponent
                    handleFunction={getTableData}
                    tooltip={"Refresh Data"}
                    // btnTitle={"refresh"}
                    variant={null}
                >
                    <RefreshIcon style={{ fontSize: '20px' }} />
                </ButtonComponent>
            </div>
        </>
    );
};

export default MatTableHeader